// extracted by mini-css-extract-plugin
export default {"draggableWrapper":"DraggableCircles_draggableWrapper__Hmwxi","draggableBullets":"DraggableCircles_draggableBullets__Q6+fM","bullet":"DraggableCircles_bullet__oWvd7"};